module.exports = __webpack_public_path__ + "media/images/header-logo-21f8ac3395e0e71f8a40a4c8e623c96f.png";